'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _Immutable = require('Immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactUtils = require('react-utils');

var _components = require('I18n/components');

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _utils = require('MeetingsLib/utils/utils');

var _color = require('MeetingsLib/utils/color');

var _color2 = require('MeetingsBase/utils/color');

var _dates = require('MeetingsBase/utils/dates');

var _enums = require('MeetingsLib/constants/enums');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _React2.default.createClass({
  displayName: 'DatePickerButton',

  propTypes: {
    availableDates: _React.PropTypes.instanceOf(_Immutable.Seq).isRequired,
    branding: _React.PropTypes.instanceOf(_Branding2.default).isRequired,
    date: _React.PropTypes.string.isRequired,
    daysToAdd: _React.PropTypes.number.isRequired,
    handleSetEventDate: _React.PropTypes.func.isRequired,
    selected: _React.PropTypes.bool,
    // troubleshoot mode
    bookableDates: _React.PropTypes.instanceOf(_Immutable.List),
    configuredAvailabilityByDate: _React.PropTypes.instanceOf(_Immutable.OrderedMap),
    editLinkURL: _React.PropTypes.string.isRequired,
    groupedTroubleshotStartTimes: _React.PropTypes.instanceOf(_Immutable.Map),
    minimumNoticeTimeBusyDays: _React.PropTypes.instanceOf(_Immutable.List),
    troubleshooting: _React.PropTypes.bool,
    userTimezone: _React.PropTypes.string.isRequired
  },

  getClassNames: function getClassNames() {
    var _props = this.props,
        selected = _props.selected,
        date = _props.date,
        availableDates = _props.availableDates;


    return (0, _reactUtils.classNames)('date-picker-btn pointer m-all-1', {
      valid: availableDates.includes(date),
      disabled: !availableDates.includes(date),
      selected: selected
    });
  },
  shouldTroubleshoot: function shouldTroubleshoot() {
    var _props2 = this.props,
        date = _props2.date,
        availableDates = _props2.availableDates,
        troubleshooting = _props2.troubleshooting;

    var dayHasAvailability = availableDates.includes(date);
    return !dayHasAvailability && troubleshooting;
  },
  getUnbookableReason: function getUnbookableReason() {
    var _props3 = this.props,
        bookableDates = _props3.bookableDates,
        configuredAvailabilityByDate = _props3.configuredAvailabilityByDate,
        date = _props3.date,
        groupedTroubleshotStartTimes = _props3.groupedTroubleshotStartTimes,
        minimumNoticeTimeBusyDays = _props3.minimumNoticeTimeBusyDays,
        userTimezone = _props3.userTimezone;


    if (!this.shouldTroubleshoot()) {
      return null;
    }
    if ((0, _dates.isDateInPast)(date, (0, _utils.getTimeAtLoad)(), userTimezone)) {
      return _enums.UNAVAILABLE_REASONS.PAST;
    }
    if (!bookableDates.includes(date)) {
      return _enums.UNAVAILABLE_REASONS.DATE_NOT_CONFIGURED;
    }
    if (!configuredAvailabilityByDate.get(date)) {
      return _enums.UNAVAILABLE_REASONS.TIME_NOT_CONFIGURED;
    }
    if (minimumNoticeTimeBusyDays.includes(date)) {
      return _enums.UNAVAILABLE_REASONS.MINIMUM_NOTICE;
    }

    var troubleshotTimesForDate = groupedTroubleshotStartTimes.get(date);
    var overlapsWithDayLongEvent = troubleshotTimesForDate && troubleshotTimesForDate.find(function (troubleshotTime) {
      return troubleshotTime.reason === _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT;
    });

    if (overlapsWithDayLongEvent) {
      return _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT;
    }
    return null;
  },
  getStyle: function getStyle() {
    var _props4 = this.props,
        selected = _props4.selected,
        primaryColor = _props4.branding.primaryColor;


    var primaryTextColor = (0, _color2.getTextColor)(primaryColor);
    if (selected) {
      return {
        color: primaryColor,
        background: primaryTextColor
      };
    }

    if (this.shouldTroubleshoot() && this.getUnbookableReason()) {
      var shadedColor = (0, _color.shadeColor)(primaryColor, 40);
      return {
        color: (0, _color2.getTextColor)(shadedColor),
        background: shadedColor
      };
    }

    return {
      color: primaryTextColor
    };
  },
  getTooltipText: function getTooltipText() {
    var editLinkURL = this.props.editLinkURL;


    var unbookableReason = this.getUnbookableReason();
    switch (unbookableReason) {
      case _enums.UNAVAILABLE_REASONS.PAST:
        return _React2.default.createElement(_components.FormattedMessage, { message: 'troubleshoot.day.past' });

      case _enums.UNAVAILABLE_REASONS.DATE_NOT_CONFIGURED:
        return _React2.default.createElement(_FormattedJSXMessage2.default, {
          message: 'troubleshoot.day.customRange_jsx',
          options: { href: editLinkURL + '/configuration', external: true },
          elements: { Link: _UILink2.default }
        });

      case _enums.UNAVAILABLE_REASONS.TIME_NOT_CONFIGURED:
        return _React2.default.createElement(_FormattedJSXMessage2.default, {
          message: 'troubleshoot.day.unset_jsx',
          options: { href: editLinkURL + '/availability', external: true },
          elements: { Link: _UILink2.default }
        });

      case _enums.UNAVAILABLE_REASONS.MINIMUM_NOTICE:
        return _React2.default.createElement(_FormattedJSXMessage2.default, {
          message: 'troubleshoot.day.minimum_jsx',
          options: { href: editLinkURL + '/configuration', external: true },
          elements: { Link: _UILink2.default }
        });

      case _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT:
        return _React2.default.createElement(_components.FormattedMessage, { message: 'troubleshoot.day.dayLong' });

      default:
        return null;
    }
  },
  renderCalendarDate: function renderCalendarDate() {
    var date = this.props.date;


    return _React2.default.createElement(
      _UIFlex2.default,
      { align: 'center', justify: 'center', className: 'calendar-date' },
      _I18n2.default.moment(date).format('D')
    );
  },
  render: function render() {
    var _props5 = this.props,
        date = _props5.date,
        daysToAdd = _props5.daysToAdd,
        handleSetEventDate = _props5.handleSetEventDate;


    var tooltipText = this.getTooltipText();
    var placement = daysToAdd > 3 ? 'top left' : 'top right';

    return _React2.default.createElement(
      _UITooltip2.default,
      {
        disabled: !this.props.troubleshooting || !tooltipText,
        maxWidth: 210,
        placement: placement,
        title: tooltipText,
        use: 'longform'
      },
      _React2.default.createElement(
        _UIBox2.default,
        {
          grow: 1,
          shrink: 1,
          basis: '100%',
          style: this.getStyle(),
          onClick: function onClick() {
            return handleSetEventDate(date);
          },
          className: this.getClassNames()
        },
        this.renderCalendarDate()
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/schedule/date/DatePickerButton.js
// module id = 378
// module chunks = 0